export const STATIC_FAQ = [
  {
    id: "register",
    label: "How do I register?",
    keywords: ["register", "sign up", "signup", "create account"],
    answer:
      "Open the Register page, complete all required fields, and submit the form. After registration, verify your email, then log in.",
  },
  {
    id: "login",
    label: "How do I login without UAE Pass?",
    keywords: ["login", "log in", "without uae", "normal login"],
    answer:
      "Use your registered email and password on the login page. This works for normal accounts only.",
  },
  {
    id: "verify",
    label: "How do I verify my account?",
    keywords: ["verify", "verification", "email verification"],
    answer:
      "Check your inbox for the verification email and open the verification link. If not received, use the resend verification option.",
  },
  {
    id: "arbitration-request",
    label: "How do I submit an arbitration request?",
    keywords: ["arbitration", "request", "submit case", "case request"],
    answer:
      "Log in, go to Dashboard > E-Services, choose Arbitration Request, fill the form details, attach documents, and submit.",
  },
  {
    id: "reset-password",
    label: "How can I reset my password?",
    keywords: ["forgot password", "reset password", "change password"],
    answer:
      "Use the Forgotten Password option on the login screen, follow the reset email instructions, and set a new password.",
  },
  {
    id: "contact-support",
    label: "How do I contact support?",
    keywords: ["support", "contact", "help", "assistance"],
    answer:
      "Use the Contact Us page on the website and submit your query with complete details so the team can assist you.",
  },
];

export const QUICK_OPTIONS = STATIC_FAQ.map(({ id, label }) => ({
  id,
  label,
}));
